import { BadgeId, BadgesStats } from '../Models';
import { WritingBadge } from './WritingBadge';
import moment from 'moment';

export default class TVBadge extends WritingBadge {
  public readonly id = BadgeId.tv;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    if (!stats.todaysPage) {
      return false;
    }

    const hour = moment(stats.todaysPage.startedWritingAt)
      .toDate()
      .getHours();
    return hour > 17 && hour < 23;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/tv.ts